import { useState, useContext } from "react"
import { GlobalContext } from "context/context/GlobalContext"
import { executeShipingGroupAction } from "services/ShippingGroupService"
import { TransactionCodeEnum } from "enums/TransactionCodeEnum"
import { NOTIFY_SHIPPED } from "helpers/constHelper"
import Logger from "classes/Logger"
import { ProcessShippingGroupActionType } from "types/OrderType"
import { EShippinggroupAction } from "enums/shippinggroupEmun"

const usePickupReservaOrder = ({
  shippingGroupId,
  setFinishedShippingGroupAction,
}: ProcessShippingGroupActionType) => {
  const [loadingPickupReserva, setLoadingPickupReserva] = useState(false)

  const { notification, errorHander } = useContext(GlobalContext)

  const handleClickPickupReservaOrder = async () => {
    setLoadingPickupReserva(true)

    try {
      const {
        data: { code },
      } = await executeShipingGroupAction({
        shippingGroupId,
        action: EShippinggroupAction.shipped,
      })

      setLoadingPickupReserva(false)

      if (code === TransactionCodeEnum.ok) {
        setFinishedShippingGroupAction(true)

        notification?.dispatch({
          type: "ADD_NOTIFICATION",
          payload: {
            message: "Productos retirados correctamente",
            title: NOTIFY_SHIPPED,
            type: "success",
          },
        })
      }
    } catch (error: any) {
      setLoadingPickupReserva(false)
      Logger.error(error)
      errorHander?.dispatch({ hasError: true, code: error.response?.status })
    }
  }

  return {
    handleClickPickupReservaOrder,
    loadingPickupReserva,
  }
}

export default usePickupReservaOrder
